import { createSelector } from 'reselect'

/**
 * Direct selector to the app state domain
 */
export const selectDomain = () => (state) => state.dashboard

export const selectProjects = () =>
  createSelector(selectDomain(), (substate) => substate.projects)

export const selectCurrentProject = () =>
  createSelector(selectDomain(), (substate) => substate.currentProject)

export const selectIsLoadingProjects = () =>
  createSelector(selectDomain(), (substate) => substate.isLoadingProjects)

export const selectIsUpdatingProject = () =>
  createSelector(selectDomain(), (substate) => substate.isUpdatingProject)

export const selectCompetitorTracking = () =>
  createSelector(selectDomain(), (substate) => substate.competitorTracking)

export const selectCompetitorTrackingLocation = () =>
  createSelector(selectDomain(), (substate) => ({
    locId: substate.competitorTracking.locId,
    lang: substate.competitorTracking.lang,
  }))
